/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorUpdateCompositionsByIdMutationRequest, VideoEditorUpdateCompositionsByIdMutationResponse, VideoEditorUpdateCompositionsByIdPathParams, VideoEditorUpdateCompositionsById401, VideoEditorUpdateCompositionsById403 } from "../models/VideoEditorUpdateCompositionsById";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { videoEditorUpdateCompositionsById } from "../axios/videoEditorUpdateCompositionsById";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const videoEditorUpdateCompositionsByIdMutationKey = () => [{ url: '/video-editor/v1/compositions/:id' }] as const

export type VideoEditorUpdateCompositionsByIdMutationKey = ReturnType<typeof videoEditorUpdateCompositionsByIdMutationKey>

export function videoEditorUpdateCompositionsByIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig<VideoEditorUpdateCompositionsByIdMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = videoEditorUpdateCompositionsByIdMutationKey()
        return mutationOptions<VideoEditorUpdateCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorUpdateCompositionsById401 | VideoEditorUpdateCompositionsById403>, {id: VideoEditorUpdateCompositionsByIdPathParams["id"], data: VideoEditorUpdateCompositionsByIdMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return videoEditorUpdateCompositionsById(id, data, config)
          },
        })

}

/**
 * @summary Update a single Composition
 * {@link /video-editor/v1/compositions/:id}
 */
export function useVideoEditorUpdateCompositionsById<TContext>(options: 
{
  mutation?: UseMutationOptions<VideoEditorUpdateCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorUpdateCompositionsById401 | VideoEditorUpdateCompositionsById403>, {id: VideoEditorUpdateCompositionsByIdPathParams["id"], data: VideoEditorUpdateCompositionsByIdMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<VideoEditorUpdateCompositionsByIdMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? videoEditorUpdateCompositionsByIdMutationKey()

          const baseOptions = videoEditorUpdateCompositionsByIdMutationOptions(config) as UseMutationOptions<VideoEditorUpdateCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorUpdateCompositionsById401 | VideoEditorUpdateCompositionsById403>, {id: VideoEditorUpdateCompositionsByIdPathParams["id"], data: VideoEditorUpdateCompositionsByIdMutationRequest}, TContext>
          

          return useMutation<VideoEditorUpdateCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorUpdateCompositionsById401 | VideoEditorUpdateCompositionsById403>, {id: VideoEditorUpdateCompositionsByIdPathParams["id"], data: VideoEditorUpdateCompositionsByIdMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<VideoEditorUpdateCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorUpdateCompositionsById401 | VideoEditorUpdateCompositionsById403>, {id: VideoEditorUpdateCompositionsByIdPathParams["id"], data: VideoEditorUpdateCompositionsByIdMutationRequest}, TContext>
      
}